/**
 * MobileSidebar — Sheet overlay for mobile nav
 *
 * Uses a simple slide-in panel (no Radix dependency for this).
 */

import { X } from 'lucide-react';
import { AppSidebar } from './AppSidebar';
import { cn } from '../../lib/utils';

interface MobileSidebarProps {
  open: boolean;
  onClose: () => void;
}

export function MobileSidebar({ open, onClose }: MobileSidebarProps) {
  return (
    <>
      {/* Backdrop */}
      <div
        className={cn(
          'fixed inset-0 z-40 bg-background/80 backdrop-blur-sm transition-opacity lg:hidden',
          open ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Sidebar panel */}
      <div
        className={cn(
          'fixed inset-y-0 left-0 z-50 w-64 bg-sidebar border-r border-sidebar-border transition-transform duration-200 lg:hidden',
          open ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        {/* Close button */}
        <div className="absolute top-3 right-3">
          <button
            onClick={onClose}
            className="rounded-md p-1 text-sidebar-foreground/70 hover:text-sidebar-foreground hover:bg-sidebar-accent/50 transition-colors"
            aria-label="Close sidebar"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* onNavigate closes the drawer when a nav link is picked (mobile UX) */}
        <AppSidebar collapsed={false} onToggleCollapse={onClose} onNavigate={onClose} />
      </div>
    </>
  );
}
